import { ServerSettingsUnauthenticated } from '~src/settings/services/ServerSettingsUnauthenticated';
import { AuthenticationType } from '~src/settings/types/IServerSettingsUnauthenticated';
import { Messages } from '../../codegen/Localize';

export enum SiteDefaultAuth {
    Local,
    ActiveDirectory,
    SAML,
    External
}

export namespace AuthenticationTypeResolutionService {

    export function authenticationType(): AuthenticationType {
        return ServerSettingsUnauthenticated.getAuthenticationType();
    }

    export function isAuthenticationAutoLogin(): boolean {
        return isWindowsCredentialsAutoLogin() ||
            authenticationType() === AuthenticationType.ClientCertificate ||
            authenticationType() === AuthenticationType.ClientCertificateWithFallback;
    }

    export function isWindowsCredentialsAutoLogin(): boolean {
        return authenticationType() === AuthenticationType.Sspi ||
            authenticationType() === AuthenticationType.Kerberos;
    }

    export function isAuthenticationSaml(): boolean {
        return authenticationType() === AuthenticationType.Saml;
    }

    export function isAuthenticationOpenId(): boolean {
        return authenticationType() === AuthenticationType.OpenId;
    }

    export function isAuthenticationExternal(): boolean {
        // This doesn't include TabId, which Tableau Server would consider external. Consider renaming the function later on.
        return isAuthenticationSaml() || isAuthenticationOpenId();
    }

    export function siteAuthDefaultLabel(): string {
        if (isAuthenticationSaml()) {
            return Messages.siteAuthenticationServerLevelAuthSAML();
        } else if (ServerSettingsUnauthenticated.isServerDomainFamilyLocal()) {
            return Messages.localDomain();
        } else if (ServerSettingsUnauthenticated.isServerDomainFamilyActiveDirectory()) {
            return Messages.activeDirectory();
        } else {
            return Messages.externalDomain();
        }
    }

    export function siteAuthDefault(): string {
        if (isAuthenticationSaml()) {
            return SiteDefaultAuth[SiteDefaultAuth.SAML];
        } else if (ServerSettingsUnauthenticated.isServerDomainFamilyLocal()) {
            return SiteDefaultAuth[SiteDefaultAuth.Local];
        } else if (ServerSettingsUnauthenticated.isServerDomainFamilyActiveDirectory()) {
            return SiteDefaultAuth[SiteDefaultAuth.ActiveDirectory];
        } else {
            return SiteDefaultAuth[SiteDefaultAuth.External];
        }
    }
}

export type AuthenticationTypeResolutionService = typeof AuthenticationTypeResolutionService;
